import React from "react";
import '../style/Obverify.css';
function VerificationSelector() {
    const endPoint=process.env.REACT_APP_API_URL;
    const goPerson = () => (window.location.href = `${endPoint}AuthPrivate`);
    const goJoint = () => (window.location.href = `${endPoint}AuthJoint`);
    const goPlc = () => (window.location.href = `${endPoint}AuthPlc`);
    return (
        <div className="app-container">
            <h2 className="title"> Welcome to Oromia Bank's Customer Identity Verification Portal</h2>
            <div className="button-group">
                <button className="login-button" onClick={goPerson}>
                     Individual Account
                </button>
                <button className="login-button" onClick={goJoint}>
                     Joint Account
                </button>
                <button className="login-button" onClick={goPlc}>
                   Corporate Account
                </button>
            </div>
        </div>
    );
}
export default VerificationSelector;